// VideoObject + BreadcrumbList JSON-LD for a scene page.
// `description` is the editorial copy or the page's generated summary;
// `tagLabels` the scene's tags as the page names them.
export const useSceneSchema = (release, { description, tagLabels } = {}) => {
  const currentSite = inject("currentSite")
  const route = useRoute()
  const origin = publicSiteOrigin(useRequestURL().href)

  // The images the page itself shows. For age-restricted visitors the API
  // already swaps in the SFW poster and stills.
  const images = computed(() =>
    [release.value?.posterUrl, ...(release.value?.thumbUrls ?? [])].filter(
      Boolean,
    ),
  )

  const schemas = computed(() => {
    if (!release.value) return []

    return [
      buildSceneVideoSchema({
        origin,
        path: route.path,
        siteName: currentSite.value.name,
        release: release.value,
        description: toValue(description),
        images: images.value,
        tagLabels: toValue(tagLabels) ?? null,
      }),
      buildSceneBreadcrumbSchema({
        origin,
        siteName: currentSite.value.name,
        title: release.value.title,
      }),
    ].filter(Boolean)
  })

  useHead({
    script: computed(() =>
      schemas.value.map((schema) => ({
        key: `schema-${schema["@type"]}`,
        type: "application/ld+json",
        innerHTML: serializeJsonLd(schema),
      })),
    ),
  })
}
